import React from 'react';
import { Gift, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';

export const GiftsPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="gifts-page">
      {/* Header */}
      <section className="py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-display text-5xl md:text-7xl mb-6 animate-fade-in text-[#e17c3b]">Cadeaux</h1>
        </div>
      </section>

      {/* Message */}
      <section className="px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 animate-slide-up">
            <div className="w-16 h-16 rounded-full bg-[#e17c3b]/10 flex items-center justify-center mx-auto mb-6">
              <Gift className="w-8 h-8 text-[#e17c3b]" />
            </div>
            <p className="font-accent italic text-2xl md:text-3xl text-[#8d5f3f] leading-relaxed">
              "Votre présence est le plus beau des cadeaux."
            </p>
            <p className="mt-4 text-[#8d5f3f]/70">
              Pour ceux qui le souhaitent, une participation libre est possible.
            </p>
          </div>
        </div>
      </section>

      {/* Revolut Link Section */}
      <section className="py-8 px-6 md:px-12" data-testid="revolut-section">
        <div className="max-w-md mx-auto">
          <div className="bg-[#fcf6f1] border border-[#e8ddd4] rounded-2xl p-8 md:p-10 animate-slide-up delay-200 shadow-md text-center">
            
            {/* Main CTA Button */}
            <a 
              href="https://revolut.me/gellybdxf6/pocket/E9zkL8GQzO"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full"
              data-testid="revolut-link"
            >
              <Button 
                size="lg"
                className="w-full rounded-full px-10 py-7 text-lg bg-[#e17c3b] hover:bg-[#c96a2f] hover:scale-105 transition-all duration-300 shadow-lg text-white"
              >
                <ExternalLink className="mr-2 h-5 w-5" />
                Envoyer un cadeau
              </Button>
            </a>

            {/* QR Code - Cadeau 2 */}
            <div className="mt-8">
              <p className="text-[#8d5f3f]/70 text-sm mb-4">Ou scannez le QR code</p>
              <div className="rounded-xl overflow-hidden inline-block">
                <img
                  src="https://customer-assets.emergentagent.com/job_wedding-invite-gc/artifacts/ctjd0zwv_Cadeau%203.png"
                  alt="QR Code Revolut"
                  className="w-48 h-48 object-contain mx-auto"
                  data-testid="cadeau-qr-code"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
